import * as React from 'react';
export const tossBankSvg = React.forwardRef(function tossBankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F8FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_tossBank__a)',
      d: 'M28 15c0 5-7.047 12-14.5 12-.5 0 1.144-9.075 1.5-10.5.5-2 1-7 4-7 4 0 9 .867 9 5.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_tossBank__b)',
      d: 'M28 15c0 5-7.047 12-14.5 12-.5 0 1.144-9.075 1.5-10.5.5-2 1-7 4-7 4 0 9 .867 9 5.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_tossBank__c)',
      d: 'M28 15c0 5-7.047 12-14.5 12-.5 0 1.144-9.075 1.5-10.5.5-2 1-7 4-7 4 0 9 .867 9 5.5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_tossBank__d)',
      d: 'M4 17c0-6 7.047-12 14.5-12 .5 0-1.144 9.075-1.5 10.5-.5 2-1 6.5-3.5 6.5-3.53 0-9.5-.287-9.5-5Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: 'url(#bi_tossBank__e)',
      d: 'M4 17c0-6 7.047-12 14.5-12 .5 0-1.144 9.075-1.5 10.5-.5 2 0 6.5-3.5 6.5-3.53 0-9.5-.287-9.5-5Z',
    }),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_tossBank__a',
          x1: 18.5,
          x2: 20,
          y1: 9.5,
          y2: 15.5,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#4192F7',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#1D49F5',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_tossBank__b',
          x1: 16.5,
          x2: 19,
          y1: 19,
          y2: 8.5,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.36,
          stopColor: '#285DE2',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#4192F7',
          stopOpacity: 0,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_tossBank__c',
          x1: 13.5,
          x2: 20,
          y1: 22.5,
          y2: 23.5,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.075,
          stopColor: '#4DAAF8',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.18,
          stopColor: '#2E6CEC',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.245,
          stopColor: '#1D49E5',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.55,
          stopColor: '#2151E6',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#2E68E7',
          stopOpacity: 0,
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_tossBank__d',
          x1: 11.679,
          x2: 11.679,
          y1: 22,
          y2: 4.486,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          stopColor: '#3173F6',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#4DAAF8',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: 'bi_tossBank__e',
          x1: 20,
          x2: 13.5,
          y1: 10,
          y2: 8.5,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.31,
          stopColor: '#1D49E5',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.455,
          stopColor: '#4DAAF8',
          stopOpacity: 0.82,
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 1,
          stopColor: '#4190F9',
          stopOpacity: 0,
        }),
      ),
    ),
  );
});
tossBankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var tossBank = {
  category: 'brand',
  colorable: false,
  name: 'tossBank',
  svg: tossBankSvg,
};
